<template>
  <div class="home_logged">
    <app-header></app-header>
    <main>
        <EmployeesComp></EmployeesComp>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import AppHeader from '@/components/AppHeader.vue';
import EmployeesComp from '@/components/EmployeesComp.vue'

export default {
  name: 'EmployeesView',
  components: {
    AppHeader,
    EmployeesComp
  }
}
</script>

<style scoped>
  .home{
    display: flex;
    justify-content: center;
    padding-top: 10%;
  }
</style>
